/// <reference types="vite/client" />
/**
 * 后台的内置词条种子：全部命名空间（用户端命名空间 + `admin`、`*-admin` + 服务端渲染的 `notify`）。只供 apps/admin 与测试使用，
 * apps/web 不得引用（D-P0-06-03；INTEGRATE D-INT-14）。
 */
import { USER_SEED_FILES } from './bundled-user.js';
import type { Messages, NamespacedLoader } from './runtime.js';
import { createSeedLoader, indexSeeds, type SeedImporters } from './seed-loader.js';
import { isAdminNamespace } from './surface.js';

// Vite 把下面的调用静态展开为按文件的动态 import
const ADMIN_SEED_FILES: SeedImporters = import.meta.glob<Messages>(['../locales/*/admin.json', '../locales/*/*-admin.json'], { import: 'default' });
const SERVER_SEED_FILES: SeedImporters = import.meta.glob<Messages>(['../locales/*/notify.json'], { import: 'default' });

const allIndex = indexSeeds(ADMIN_SEED_FILES, SERVER_SEED_FILES, USER_SEED_FILES);

/** 后台专用命名空间（`admin`、`*-admin`）。 */
export const ADMIN_NAMESPACES: readonly string[] = allIndex.namespaces.filter(isAdminNamespace);

/** 全部内置命名空间。 */
export const BUNDLED_NAMESPACES: readonly string[] = allIndex.namespaces;

/** 后台内置种子：全部命名空间。apps/admin 使用。 */
export const adminSeedLoader: NamespacedLoader = createSeedLoader(allIndex);

/** 读取内置种子（全部命名空间）；未知命名空间返回空对象。保留骨架名称，新代码请用 userSeedLoader / adminSeedLoader。 */
export const bundledLoader: NamespacedLoader = adminSeedLoader;
